import { ArrowRight, ArrowUpRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { SocialIcon } from './SmartCampusNavigation';

const routes = [
  { label: 'Start free', note: 'Set your campus in motion.', to: '/register' },
  { label: 'Explore the platform', note: 'See every connected part.', to: '/platform' },
  { label: 'Talk to our team', note: 'Find the right next step.', to: '/contact-us' },
];

const companyLinks = [
  { label: 'About us', to: '/about-us' },
  { label: 'News & updates', to: '/news-and-updates' },
  { label: 'Terms of service', to: '/terms-of-service' },
  { label: 'Data processing', to: '/data-processing-addendum' },
];

const socialLinks = [
  { label: 'LinkedIn', href: 'https://www.linkedin.com', icon: 'linkedin' },
  { label: 'Instagram', href: 'https://www.instagram.com', icon: 'instagram' },
  { label: 'TikTok', href: 'https://www.tiktok.com', icon: 'tiktok' },
  { label: 'Facebook', href: 'https://www.facebook.com', icon: 'facebook' },
];

export function PublicFooter() {
  return (
    <footer className="public-footer">
      <div className="public-footer-inner">
        <div className="public-footer-intro">
          <span className="public-footer-kicker"><i /> Your campus, onward</span>
          <h2>Happy students healthy<br /><i>business</i></h2>
          <p>Build a calmer, more connected way to run the work behind learning.</p>
          <Link className="public-footer-cta" to="/register">Try SmartCampus free <ArrowUpRight size={18} /></Link>
        </div>
        <nav className="public-footer-routes" aria-label="Footer actions">
          {routes.map(({ label, note, to }, index) => <Link key={label} to={to}><span>0{index + 1}</span><div><b>{label}</b><small>{note}</small></div><ArrowRight size={20} /></Link>)}
        </nav>
      </div>
      <div className="public-footer-wordmark" aria-hidden="true"><span>Smart</span><strong>Campus</strong></div>
      <div className="public-footer-bottom">
        <p>Built for the people<br />who make learning happen.</p>
        <nav className="public-footer-company" aria-label="Company links">{companyLinks.map(({ label, to }) => <Link key={label} to={to}>{label}</Link>)}</nav>
        <div className="public-footer-socials" aria-label="Social links">{socialLinks.map(({ label, href, icon }) => <a href={href} key={label} rel="noreferrer noopener" target="_blank" aria-label={label}><SocialIcon icon={icon} /></a>)}</div>
        <small>Copyright {new Date().getFullYear()} SmartCampus Africa</small>
      </div>
    </footer>
  );
}
